import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AtpEditorComponent} from './atp-editor.component';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import {AngularEditorModule} from '@kolkov/angular-editor';

@NgModule({
  declarations: [
    AtpEditorComponent
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatButtonModule,
    MatIconModule,
    MatProgressBarModule,
    AngularEditorModule,
    FormsModule
  ],
  exports: [
    AtpEditorComponent
  ],
  providers: [
  ]
})
export class AtpEditorModule { }
